<template>
    <div class="toolbar-comp">
        <div class="reservation barbtn" @click="gotoReservation">
            <i class="icon"></i>
            <span class="text">{{ t('freeConsultation') }}</span>
        </div>
        <div class="gotop barbtn" @click="gotop"></div>
    </div>
</template>

<script setup>
import { useScrollToTopBy  } from "@/hooks/useAnime.js";
import { gotoReservation } from '@/hooks/useCommon.js'
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const gotop = () => {
	$("body,html").animate(
		{
			//html是最外层标签，可以代表整个页面；body 是它二级标签，可以用它代表页面的文档部分
			// "body,html"都写上，兼容多浏览器
			scrollTop: 0,
		},
		500
	); //500是滚动到顶部所需要的时间0.5秒

	// useScrollToTopBy({
	// 	el: window, 
	// 	duration: .5,
	// 	scrollTo: { y: 0, autoKill: true },
	// 	ease: "power2"
	// })
};
</script>

<style lang="scss" scoped>
.toolbar-comp{
    position: fixed;
    right: 1rem;
    bottom: 6.25rem;
    width: 60px;
    height: 110px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 1;
    cursor: pointer;
    
    .reservation{
        height: 60px;
        background: #1300FF;
        color: #FFFFFF;
        box-shadow: 0px 4px 13px 0px rgba(18,18,44,0.08), 0px -4px 13px 0px rgba(0,0,0,0.08);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .icon{
            width: 24px;
            height: 24px;
            background: url('~@/assets/imgs/icon/message.png') no-repeat center center;
            background-size: cover;
        }
        .text{
            margin-top: 3px;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            line-height: 1;
            text-align: center;
            transform: scale(.75);
            width: max-content;
            display: inline-block;
            width: 130%;
        }
    }
    .gotop{
        height: 60px;
        background: #FFFFFF;
        box-shadow: 0rem 0.25rem 0.81rem 0rem rgba(18,18,44,0.08);
        display: none;
        position: relative;
        &::before{
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            width: 24px;
            height: 24px;
            background: #FFFFFF url('~@/assets/imgs/icon/gotop.png') no-repeat center center;
            background-size: cover;
        }
        .scroll-overflow-screen &{
            display: block;
        }
    }

}
.app-small .toolbar-comp{
    right: .8rem;
    bottom: 5.63rem;
    height: 106px;

    .reservation{
        .text{
            display: none;
        }
    }
    .barbtn{
        border-radius: 50%;
    }
    .gotop{
        margin-top: 10px;
    }
}
</style>